<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6" v-if="load_data">
    <badge-default class="my-2" :label="`Lotes: ${total_exported_batches}`" />
    <div class="table-first-container">
      <div class="table-second-container">
        <div class="table-third-container">
          <table class="table">
            <thead class="table-header">
              <tr>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.week") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.registered_at") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.exported_batch.batch_code") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.exported_batch.crop_field") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.exported_batch.total_amount") }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{ $t("model.harvested_batch.discarded_weight") }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                v-for="(exported_batch, index) in exported_batches"
                :key="index"
                class="table-row"
              >
                <td class="table-cell">{{ exported_batch.week }}</td>
                <td class="table-cell">
                  {{ dateFormatter(exported_batch.registered_at) }}
                </td>
                <td class="table-cell">
                  <button
                    @click.prevent="showBatch(exported_batch)"
                    class="link"
                  >
                    {{ exported_batch.batch_code }}
                  </button>
                </td>
                <td class="table-cell">
                  {{ exported_batch.crop_field?.name }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(exported_batch.total_weight) }}
                </td>
                <td class="table-cell">
                  {{ numberWithPrecision(exported_batch.discarded_weight) }}
                </td>
                <td class="table-cell">
                  <percent-bar
                    :ok_percent="exported_batch.ok_percent"
                    :err_percent="exported_batch.discarded_percent"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <table-paginator
      v-model="current_page"
      :total_rows="total_exported_batches"
      :rows_per_page="rows_per_page"
    />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/production/query_by_provider/show_provider.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";
import BadgeDefault from "@/components/views/layout/BadgeDefault.vue";
import PercentBar from "@/components/views/layout/PercentBar.vue";
export default {
  name: "PRODReportingProcessShowReportsDetails",
  components: {
    TablePaginator,
    BadgeDefault,
    PercentBar
  },
  props: {
    organization_id: { required: true },
    provider_id: { required: true },
    provider_type: { required: true },
    agro_exporter_process_id: { required: true }
  },
  data() {
    return {
      load_data: false,
      current_page: 1,
      total_exported_batches: 0,
      rows_per_page: 14,
      show_batch: false,
      exported_batches: [],
      seriesM: [40, 30, 15, 10, 5]
    };
  },
  computed: {
    harvested_batches_with_percents() {
      return this.exported_batches.filter(
        exported_batch => exported_batch.discarded_weight > 0
      );
    },
    discard_percent() {
      if (this.exported_batch == null) return 0;
      return (
        (Number(this.exported_batch.discarded_weight) /
          Number(this.exported_batch.total_weight)) *
        100
      );
    }
  },
  created() {
    this.fetchTotalPages();
    this.fetchExportedBatches();
  },
  methods: {
    fetchExportedBatches: async function () {
      let response = await Requester.fetchExportedBatches(
        this.organization_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id,
        this.current_page - 1,
        this.rows_per_page
      );
      this.exported_batches = response.data;
      this.fillPercentValues();
      this.load_data = true;
    },
    fetchTotalPages: async function () {
      let response = await Requester.fetchExportedBatchesTotal(
        this.organization_id,
        this.agro_exporter_process_id,
        this.provider_type,
        this.provider_id
      );
      this.total_exported_batches = response.data;
      this.available_pages = Array.from(
        { length: Math.ceil(this.total_exported_batches / this.rows_per_page) },
        (_, i) => i + 1
      );
    },
    fillPercentValues() {
      this.exported_batches.forEach(exported_batch => {
        const discarded_percent = this.discardPercent(exported_batch);
        exported_batch["discarded_percent"] = discarded_percent;
        exported_batch["ok_percent"] = 100 - discarded_percent;
      });
    },
    discardPercent(exported_batch) {
      let percent =
        (Number(exported_batch.discarded_weight) /
          Number(exported_batch.total_weight)) *
        100;
      return Math.round(percent);
    },
    showBatch(exported_batch) {
      this.$router.push({
        name: this.routeName("show_exported_batch"),
        params: {
          organization_id: this.organization_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          provider_id: this.provider_id,
          provider_type: this.provider_type,
          exported_batch_id: exported_batch.id
        }
      });
    },
    harvestedPackages(exported_batch) {
      return exported_batch.harvested_packages.reduce((p, har_pkg) => {
        let name = har_pkg.crop_har_package.name;
        if (!Object.hasOwn(p, name)) p[name] = 0;
        p[name] += har_pkg.number;
        return p;
      }, {});
    },
    exportedPackages(exported_batch) {
      return exported_batch.packages.reduce((p, exp_pkg) => {
        let name = exp_pkg.exporter_process_crop_package.name;
        if (!Object.hasOwn(p, name)) p[name] = 0;
        p[name] += exp_pkg.quantity;
        return p;
      }, {});
    }
  },
  watch: {
    current_page: function () {
      this.fetchExportedBatches();
    }
  }
};
</script>
